import BaseModel from "../../../../../core/components/input-widget/BaseModel";
import Increment from "../../../../../core/components/increment-tiers/Increment.model";
import {NO_EMPTY_SPACE_AND_FORWARD_SLASH} from "@/plugins/vee-validate";

export default class IncrementCalculationModel extends BaseModel {
  increment_calculation_source = [];

  rules = {
    increment_calculation_source: 'required',
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
